<script>
import {api} from "@/app/services/api.service";



export default {
  name: "PractitionerRenewals",
  components: {},
  props:{
    upn:String
  },
  data(){
    return{
      renewalInfo:null,
      annualReturnsInfo:null,
      annualReturnsModal:false
    }
  },
  mounted() {
    this.fetchAppointmentsInfo()
  },
  methods:{
    async fetchAppointmentsInfo() {
      await api().get("insolvency/practitioner/renewals?upn="+this.upn)
          .then((response) => {
            if(response && response.data){
              this.renewalInfo = response.data
            }
          })
          .catch((error) => {
            if(error) {
              // this.loading = false;
            }
          });

    },

  }
}
</script>

<template>
<div>



  <div style="width: 80%">
    <table  v-for="(renewal, indx) in renewalInfo" :key="'j'+indx" class="min-w-full leading-normal mb-1 text-gray border">
      <thead>

      <tr style="background-color: #f6f6f6;">
        <td colspan="12" class="px-2 py-2">
          <div class="flex justify-content-between">
            <div>
              <div>
                <span>{{(indx + 1)}}. Renewal for the Year {{renewal.createdAt ? renewal.createdAt : ""}}</span>

              </div>
              <div class="text-xs">
                <b>TrackingNo:</b> {{renewal.trackingNumber}}, <b>Date:</b> {{renewal.createdAt}}
              </div>
            </div>

            <div>
              <span class="text-white px-3 rounded-md ml-4 py-1 text-sm" :class="renewal.status === 'APPROVED' ? 'bg-green':'bg-red'">{{renewal.status}}</span>
            </div>


          </div>
        </td>
      </tr>

      <!--    <tr>
            <td class="p-4">

              <b-row>
                <b-col cols="6">
                  <div class="mb-2">
                    <label class="text-gray text-xs">Name</label>
                    <b-form-group>
                      <b-form-input
                          style="color: #505050;"
                          id="companyName"
                          class="form-text noFocus text-xs"
                          type="text"
                          :disabled="true"
                          v-model="annual.name"
                          required>
                      </b-form-input>
                    </b-form-group>
                  </div>

                  <div class="mb-2">
                    <label class="text-gray text-xs">UPN</label>
                    <b-form-group>
                      <b-form-input
                          style="color: #505050;"
                          id="companyName"
                          class="form-text noFocus text-xs"
                          type="text"
                          :disabled="true"
                          v-model="annual.upn"
                          required>
                      </b-form-input>
                    </b-form-group>
                  </div>


                </b-col>

                <b-col cols="6">


                  <div class="mb-2">
                    <label class="text-gray text-xs">Status</label>
                    <b-form-group>
                      <b-form-input
                          style="color: #505050;"
                          id="companyName"
                          class="form-text noFocus text-xs"
                          type="text"
                          :disabled="true"
                          v-model="annual.status"
                          required>
                      </b-form-input>
                    </b-form-group>
                  </div>

                  <b-row>
                    <b-col cols="6">
                      <div class="mb-2">
                        <label class="text-gray text-xs">Start date</label>
                        <b-form-group>
                          <b-form-input
                              style="color: #505050;"
                              id="companyName"
                              class="form-text noFocus text-xs"
                              type="text"
                              :disabled="true"
                              v-model="annual.startDate"
                              required>
                          </b-form-input>
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="mb-2">
                        <label class="text-gray text-xs">End date</label>
                        <b-form-group>
                          <b-form-input
                              style="color: #505050;"
                              id="companyName"
                              class="form-text noFocus text-xs"
                              type="text"
                              :disabled="true"
                              v-model="annual.endDate"
                              required>
                          </b-form-input>
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>





                </b-col>
              </b-row>




            </td>
          </tr>-->

      </thead>
    </table>
  </div>




</div>
</template>

<style scoped>

</style>